import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import './index.scss';
import App from './App';
// import 'fontawesome-4.7/css/font-awesome.min.css';
// import reportWebVitals from "./reportWebVitals";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { BrowserRouter as Router } from 'react-router-dom';
// import { PersistGate } from 'redux-persist/lib/integration/react';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const root = createRoot(document.getElementById('root'));

const location = window.location.href
if (!location.includes(baseUrl)) {
  window.location.replace(baseUrl)
}


root.render(
  <Router basename={baseUrl}>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  // document.getElementById('root')
);

// reportWebVitals();
